<template>
  <div class="product-list">
    <div
      v-for="(allocation, allocationIndex) in allocations"
      :key="allocationIndex"
      data-testid="product-list"
    >
      <div class="product-list__column">
        <HeadingProductListItem
          data-testid="product-allocation-header"
          :name="allocation.type"
          :percentage="allocation.allocValue.formatted"
          :color="allocation.color"
        />
      </div>
      <div
        v-for="(product, productIndex) in allocation.products"
        :key="productIndex"
      >
        <ProductAllocationCard
          :is-clickable="isClickable(product)"
          :product-name="product.name"
          :product-allocation="product.allocValue.formatted"
          :product-total-balance="product.totalBalance.formatted"
          :aria-label="`Ver detalhes do produto ${product.name}`"
          data-testid="product-list-item"
          @onclick="() => handleProductClick(product)"
          @keydown.enter.space="handleProductClick(product)"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" scoped>
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { HeadingProductListItem } from '../HeadingProductListItem';
import { ProductAllocationCard } from '@/modules/common/components/cards/ProductAllocationCard';
import { trackDetailInstrument } from './track-events';
import {
  IProductAllocation,
  IProduct
} from '@/modules/wealth/services/investment';

@Component({
  components: { HeadingProductListItem, ProductAllocationCard }
})
export default class PortfolioProductsList extends Vue {
  @Prop({ type: Array, required: true })
  readonly allocations!: IProductAllocation[];

  @Emit('product-click')
  private emitProductClick(productApiId: string) {
    return productApiId;
  }

  isClickable(item: IProduct) {
    return !!item.instrumentDetailApiId;
  }

  handleProductClick(product: IProduct) {
    this.emitProductClick(product.instrumentDetailApiId);
    trackDetailInstrument(true, product.rootClassName, product.name);
  }
}
</script>

<style lang="less" scoped>
.product-list__column {
  display: flex;
  margin-top: @size-spacing-x300;
  align-items: center;

  & div:first-of-type,
  div:last-of-type,
  h4:first-of-type,
  h4:last-of-type {
    flex: 1;
  }
}
</style>
